// Shared color palettes for charts

export const CHART_COLOR_PALETTE = {
    BACKGROUND: [
        'rgba(231, 97, 1, 0.8)',    // Orange
        'rgba(36, 63, 241, 0.8)',   // Blue
        'rgba(82, 8, 241, 0.8)',    // Purple
        'rgba(2, 128, 21, 0.8)',    // Green
        'rgba(215, 208, 4, 0.8)',   // Yellow
        'rgba(13, 132, 244, 0.8)',  // Light Blue
        'rgba(222, 8, 241, 0.8)',   // Magenta
        'rgba(36, 36, 36, 0.8)',    // Dark Gray
        'rgba(255, 99, 132, 0.8)',  // Pink
        'rgba(54, 162, 235, 0.8)',  // Cyan
        'rgba(255, 205, 86, 0.8)',  // Light Yellow
        'rgba(75, 192, 192, 0.8)',  // Teal
        'rgba(153, 102, 255, 0.8)', // Light Purple
        'rgba(255, 159, 64, 0.8)',  // Light Orange
        'rgba(199, 199, 199, 0.8)', // Light Gray
        'rgba(83, 102, 255, 0.8)',  // Indigo
        'rgba(255, 99, 255, 0.8)',  // Hot Pink
        'rgba(99, 255, 132, 0.8)',  // Light Green
        'rgba(255, 195, 0, 0.8)',   // Gold
        'rgba(128, 0, 128, 0.8)'    // Dark Purple
    ],
    BORDER: [
        'rgb(243, 117, 6)',          // Orange
        'rgba(13, 13, 231, 0.91)',   // Blue
        'rgb(91, 7, 209)',           // Purple
        'rgba(1, 217, 33, 0.8)',     // Green
        'rgba(255, 247, 0, 0.8)',    // Yellow
        'rgba(0, 131, 254, 0.8)',    // Light Blue
        'rgba(232, 2, 253, 0.8)',    // Magenta
        'rgba(62, 62, 62, 0.8)',     // Dark Gray
        'rgba(255, 99, 132, 1)',     // Pink
        'rgba(54, 162, 235, 1)',     // Cyan
        'rgba(255, 205, 86, 1)',     // Light Yellow
        'rgba(75, 192, 192, 1)',     // Teal
        'rgba(153, 102, 255, 1)',    // Light Purple
        'rgba(255, 159, 64, 1)',     // Light Orange
        'rgba(199, 199, 199, 1)',    // Light Gray
        'rgba(83, 102, 255, 1)',     // Indigo
        'rgba(255, 99, 255, 1)',     // Hot Pink
        'rgba(99, 255, 132, 1)',     // Light Green
        'rgba(255, 195, 0, 1)',      // Gold
        'rgba(128, 0, 128, 1)'       // Dark Purple
    ]
};

// Brighter palette for dark mode (full opacity, moderately saturated)
export const CHART_COLOR_PALETTE_DARK = {
    BACKGROUND: [
        'rgba(210, 100, 20, 0.9)',    // Orange
        'rgba(55, 80, 230, 0.9)',     // Blue
        'rgba(105, 50, 220, 0.9)',    // Purple
        'rgba(25, 150, 50, 0.9)',     // Green
        'rgba(200, 190, 30, 0.9)',    // Yellow
        'rgba(40, 140, 230, 0.9)',    // Light Blue
        'rgba(200, 50, 220, 0.9)',    // Magenta
        'rgba(120, 120, 120, 0.9)',   // Gray
        'rgba(220, 100, 130, 0.9)',   // Pink
        'rgba(65, 160, 225, 0.9)',    // Cyan
        'rgba(220, 190, 75, 0.9)',    // Light Yellow
        'rgba(80, 190, 190, 0.9)',    // Teal
        'rgba(150, 110, 225, 0.9)',   // Light Purple
        'rgba(220, 150, 70, 0.9)',    // Light Orange
        'rgba(185, 185, 185, 0.9)',   // Light Gray
        'rgba(90, 110, 225, 0.9)',    // Indigo
        'rgba(220, 110, 220, 0.9)',   // Hot Pink
        'rgba(90, 220, 130, 0.9)',    // Light Green
        'rgba(220, 185, 30, 0.9)',    // Gold
        'rgba(155, 45, 155, 0.9)'    // Dark Purple
    ],
    BORDER: [
        'rgb(230, 120, 40)',          // Orange
        'rgb(75, 100, 245)',          // Blue
        'rgb(125, 70, 235)',          // Purple
        'rgb(40, 175, 70)',           // Green
        'rgb(220, 210, 50)',          // Yellow
        'rgb(60, 160, 245)',          // Light Blue
        'rgb(220, 70, 235)',          // Magenta
        'rgb(150, 150, 150)',         // Gray
        'rgb(235, 120, 150)',         // Pink
        'rgb(85, 180, 240)',          // Cyan
        'rgb(235, 210, 95)',          // Light Yellow
        'rgb(100, 210, 210)',         // Teal
        'rgb(170, 130, 240)',         // Light Purple
        'rgb(235, 170, 90)',          // Light Orange
        'rgb(205, 205, 205)',         // Light Gray
        'rgb(110, 130, 240)',         // Indigo
        'rgb(235, 130, 235)',         // Hot Pink
        'rgb(110, 235, 150)',         // Light Green
        'rgb(235, 205, 50)',          // Gold
        'rgb(175, 60, 175)'           // Dark Purple
    ]
};

// Specialized color schemes for specific chart types

// Business Unit chart gradient palette (blue→cyan→teal→green→lime→yellow→orange)
export const BUNIT_COLORS = {
    BACKGROUND: [
        'rgba(1, 46, 244, 0.61)',
        'rgba(12, 203, 241, 0.8)',
        'rgba(8, 241, 214, 0.8)',
        'rgba(2, 239, 124, 0.8)',
        'rgba(2, 128, 21, 0.8)',
        'rgba(206, 244, 13, 0.8)',
        'rgba(241, 218, 8, 0.8)',
        'rgba(243, 131, 11, 0.8)',
    ],
    BORDER: [
        'rgba(54, 86, 228, 0.61)',
        'rgba(62, 198, 225, 0.8)',
        'rgba(72, 227, 209, 0.8)',
        'rgba(58, 224, 144, 0.8)',
        'rgba(46, 157, 62, 0.8)',
        'rgba(195, 215, 90, 0.8)',
        'rgba(221, 206, 71, 0.8)',
        'rgba(207, 144, 76, 0.8)',
    ]
};

export const BUNIT_COLORS_DARK = {
    BACKGROUND: [
        'rgba(40, 75, 225, 0.9)',
        'rgba(30, 190, 225, 0.9)',
        'rgba(30, 220, 200, 0.9)',
        'rgba(30, 220, 130, 0.9)',
        'rgba(25, 150, 50, 0.9)',
        'rgba(190, 220, 40, 0.9)',
        'rgba(220, 205, 30, 0.9)',
        'rgba(220, 135, 30, 0.9)',
    ],
    BORDER: [
        'rgba(60, 95, 240, 1)',
        'rgba(50, 210, 240, 1)',
        'rgba(50, 235, 215, 1)',
        'rgba(50, 235, 150, 1)',
        'rgba(45, 175, 70, 1)',
        'rgba(210, 235, 60, 1)',
        'rgba(235, 220, 50, 1)',
        'rgba(235, 155, 50, 1)',
    ]
};

export const DEVELOPER_PROGRAM_COLORS = {
    BACKGROUND: {
        NON_DEVELOPER_PROGRAM: 'rgba(220, 220, 220, 0.8)',  // Light gray - APIs not in Developer Program
        DEVELOPER_PROGRAM: 'rgba(34, 139, 34, 0.8)'         // Green - Developer Program APIs (highlighting the subset)
    },
    BORDER: {
        NON_DEVELOPER_PROGRAM: 'rgba(200, 200, 200, 1)',    // Non-Developer Program border - Gray
        DEVELOPER_PROGRAM: 'rgb(34, 139, 34)'               // Developer Program border - Green
    }
};

export const DEVELOPER_PROGRAM_COLORS_DARK = {
    BACKGROUND: {
        NON_DEVELOPER_PROGRAM: 'rgba(160, 160, 160, 0.9)',
        DEVELOPER_PROGRAM: 'rgba(40, 170, 40, 0.9)'
    },
    BORDER: {
        NON_DEVELOPER_PROGRAM: 'rgba(190, 190, 190, 1)',
        DEVELOPER_PROGRAM: 'rgb(55, 195, 55)'
    }
};
